import React from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import MyInput from "../../../components/questionContainer/formElements/Input";
import MyEmail from "../../../components/questionContainer/formElements/Email";
import MyNumber from "../../../components/questionContainer/formElements/Number";
import MyDatePicker from "../../../components/questionContainer/formElements/DatePicker";
import MyRadio from "../../../components/questionContainer/formElements/Radio";
import MyCheckBox from "../../../components/questionContainer/formElements/CheckBox";
import MyDropdown from "../../../components/questionContainer/formElements/Dropdown";
import YesNo from "../../../components/questionContainer/formElements/YesNo";
import MyAmount from "../../../components/questionContainer/formElements/Amount";
import MyFile from "../../../components/questionContainer/formElements/File";
import { Spin } from "antd";

const UploadBookKeeping = ({
  isOpen,
  setIsOpen,
  questionList,
  isQuestionLoading,
  isLoadingSubmit,
  handleSubmit,
}) => {
  const QuestionRender = ({ question, isBookKeeping }) => {
    switch (question?.field_type) {
      case "input":
        return <MyInput data={question} isBookKeeping={isBookKeeping} />;
      case "email":
        return <MyEmail data={question} isBookKeeping={isBookKeeping} />;
      case "number":
        return <MyNumber data={question} isBookKeeping={isBookKeeping} />;
      case "date":
        return <MyDatePicker data={question} isBookKeeping={isBookKeeping} />;
      case "radio":
        return <MyRadio data={question} isBookKeeping={isBookKeeping} />;
      case "checkbox":
        return <MyCheckBox data={question} isBookKeeping={isBookKeeping} />;
      case "dropdown":
        return <MyDropdown data={question} isBookKeeping={isBookKeeping} />;
      case "yes-no":
        return <YesNo data={question} isBookKeeping={isBookKeeping} />;
      case "amount":
        return <MyAmount data={question} isBookKeeping={isBookKeeping} />;
      case "file":
        return <MyFile data={question} isBookKeeping={isBookKeeping} />;
      default:
        return null;
    }
  };
  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Upload File"
      width={1000}
    >
      {isQuestionLoading ? (
        <div className="flex justify-center">
          <Spin />
        </div>
      ) : (
        <>
          {questionList?.map((question, index) => (
            <QuestionRender
              key={index}
              question={question}
              isBookKeeping={true}
            />
          ))}
          <div className="text-center mt-5">
            <LoadableButton
              type="submit"
              lable="Submit"
              isLoading={isLoadingSubmit}
              loadingLable="Submitting..."
              onClick={handleSubmit}
            />
          </div>
        </>
      )}
    </ModalComponent>
  );
};

export default UploadBookKeeping;
